import React from 'react';
import './product.css';
import prdbg from '../assets/prdbg.svg';
import moma from '../assets/moma.svg';

const Product = () => {
  return (
    <div className='duf__product section__padding' id='product'>
      <div className='duf__product-content'>
        <div className='duf__product-title'>
          <h1>Our Product</h1>
          </div>
          <div className='duf__product-container'>
            <div className="duf__product-image">
              <img src={prdbg} alt="headbg"/>
            </div> 
            <div className='duf__product-moma'>
              <img src={moma} alt="moma"/>
              <p>Moma, the budget management app is our first iOS product. Compared with other similar products, Moma could easily help user to manage expenditure in foreign currencies.</p>
            </div>
          </div>
      </div>
    </div>
  )
}

export default Product